import React from "react";
import CTAButtons from "../CTAButtons";
import Image from "next/image";
import { container_classname } from "../constants";
import { LuArrowUpRight } from "react-icons/lu";
import { isJSXElement } from "@utils/common";

export interface HerosectionProps {
    chipTitle: string;
    title: string | JSX.Element;
    description: string;
    primaryButtonText: string;
    imageUrl: string;
    enableDemoButton?: boolean;
    demoBtnText?: string;
    demoLink?: string;
    backgroundColor?: boolean;
}

const herosectionData: HerosectionProps = {
    chipTitle: "EDUCATION",
    title: "Achieve 35% growth in admissions with WhatsApp automation",
    description: " From the first student query to filling in the admissions form to making the course payment, do it all using Gallabox's WhatsApp automation features.",
    primaryButtonText: "Try for Free",
    imageUrl: "https://assets.gallabox.com/gb-home/industry-logos/education/education-industries.png",
};
const Herosection: React.FC<{ herosection?: HerosectionProps; customCTAButton?: React.ReactNode }> = ({ herosection = herosectionData, customCTAButton }) => {
    const { chipTitle, title, description, primaryButtonText, imageUrl, enableDemoButton, demoBtnText, backgroundColor } = herosection;
    return (
        <section style={{ background: backgroundColor ? "linear-gradient(265deg, #A1D8FF -7.73%, #396AFF 19.04%, #00238D 61.31%, #000 102.16%" : "" }}>
            <section className={`${container_classname} flex md:flex-row flex-col md:py-20 md:pt-40 py-12 gap-10 gap-x-20`}>
                <div className="md:w-1/2 w-full">
                    <p className="text-base font-semibold mb-3 md:block hidden" style={{ color: backgroundColor ? "#0AE8F0" : "#3364FA" }}>
                        {chipTitle}
                    </p>

                    {isJSXElement(title) ? (
                        title
                    ) : (
                        <h1 className={`${backgroundColor ? "text-white" : "text-black"} md:text-7xl text-5xl mb-12 font-bold`} style={{ fontFamily: "Degular Variable" }}>
                            {title}
                        </h1>
                    )}

                    <p className={`${backgroundColor ? "text-white" : "text-black"} text-xl mb-4`}>{description}</p>
                    <div className="flex gap-6">
                        {customCTAButton ? customCTAButton : <CTAButtons primaryButtonText={primaryButtonText} />}
                        {enableDemoButton && (
                            <a className="border border-gray-800 border-solid py-4 px-6 rounded-md flex items-center gap-1 font-semibold hover:no-underline cursor-pointer" href="">
                                {demoBtnText}
                                <span>
                                    <LuArrowUpRight size={20} />
                                </span>
                            </a>
                        )}
                    </div>
                </div>
                <Image width={540} height={520} src={imageUrl} alt={chipTitle} className="mb-auto py-10" />
            </section>
        </section>
    );
};

export default Herosection;
